const initialState = {
  open: false,
  expandPayer: false,
  expandServiceLevelSection: false,
};
export default initialState;
